import { exportTransactions } from "@/api/transactions";
import { useToast } from "@/components/ui/use-toast";
import { useMutation } from "@tanstack/react-query";

export const useExportTransactions = () => {
	const { toast } = useToast();
	return useMutation({
		mutationFn: exportTransactions,
		onSuccess: (blob) => {
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = "transactions.csv";
			a.click();
			window.URL.revokeObjectURL(url);
		},
		onError: (error) => {
			toast({
				title: "Export failed",
				description: error.message,
				variant: "destructive",
			});
		},
	});
};
